module.exports = __webpack_public_path__ + "static/media/7.acb6844a.png";